import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/Aboutus';
import Services from './pages/Services';
import Contact from './pages/Contact';
import WhyUs from './pages/About'; // Assuming you put WhyUs in components folder
import Footer from './components/Footer';

function App() {
  // Initialize language from browser or default to 'en'
  const [language, setLanguage] = useState(() => {
    return navigator.language.startsWith('ar') ? 'ar' : 'en';
  });
  
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Update body dir and dark mode class on changes
  useEffect(() => {
    document.body.dir = language ===  'ltr';

    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [language, darkMode]);

  return (
    <Router>
      <Navbar 
        language={language} 
        setLanguage={setLanguage} 
        darkMode={darkMode} 
        setDarkMode={setDarkMode} 
      />
      <Routes>
        <Route 
          path="/" 
          element={
            <>
              <Home language={language} darkMode={darkMode} />
              <WhyUs language={language} darkMode={darkMode} />
            </>
          } 
        />
        <Route path="/about" element={<About language={language} darkMode={darkMode} />} />
        <Route path="/services" element={<Services language={language} darkMode={darkMode} />} />
        <Route path="/contact" element={<Contact language={language} darkMode={darkMode} />} />
      </Routes>
      <Footer
      language={language} 
        setLanguage={setLanguage} 
        />
    </Router>
  );
}

export default App;
